import Application from "../../Application";
import AddDocumentTypeVisibilityLevelsInteractor from "../../documentTypes/interactors/AddDocumentTypeVisibilityLevelsInteractor";
import { IVisibilityLevel } from "../../documentTypes/model/VisibilityLevel";
import Constants from "../common/Constants";

export default class AddCaseLawDocumentTypeVisibilityLevelsInteractor {
  private application: Application;
  private addDocumentTypeVisibilityLevelsInteractor: AddDocumentTypeVisibilityLevelsInteractor;

  constructor({ application, addDocumentTypeVisibilityLevels }) {
    this.application = application;
    this.addDocumentTypeVisibilityLevelsInteractor =
      addDocumentTypeVisibilityLevels;
  }

  execute(
    organisationId: number,
    caseLawDocumentTypeId: number,
    visibilityLevelListList: IVisibilityLevel[]
  ) {
    return this.addDocumentTypeVisibilityLevelsInteractor.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.caseLawDocumentTypePath}/${caseLawDocumentTypeId}`,
      visibilityLevelListList
    );
  }
}
